import { COLOR_PRIMARY, COLOR_PRIMARY_DARK } from "#constants/Styles"
import MainDetailsHistoryDialog from "#core/components/main-details/MainDetailsHistory"
import { useVacanteRedux } from "#vacancy/redux/slice"
import { vacancyHistoryGet } from "#vacancy/services/api"
import AccountBoxIcon from "@mui/icons-material/AccountBox"
import GppGoodIcon from "@mui/icons-material/GppGood"
import { useMemo } from "react"

export default function VacancyDetailsHistory({ ...props }) {
	const { vacancyId } = useVacanteRedux()
	const params = useMemo(() => ({ id: vacancyId }), [vacancyId])
	const listItems = [
		{
			icon: <AccountBoxIcon />,
			key: "new vacante",
		},
		{
			icon: <GppGoodIcon />,
			key: "auth",
		},
		{
			icon: <GppGoodIcon />,
			key: "Recepción ",
		},
	]
	const bgcolor = (action) => {
		if (action.includes("eliminado")) return "red"
		if (action.includes("new")) return COLOR_PRIMARY
		if (action.includes("vobo")) return "green"
		if (action.includes("recepción ")) return "green"
		return COLOR_PRIMARY_DARK
	}
	return (
		<MainDetailsHistoryDialog
			{...{ apiCall: vacancyHistoryGet, bgcolor, listItems, params, ...props }}
		/>
	)
}
